export const DEFAULT_SIZE = 16;
export const DEFAULT_ICON_PADDING = 4;
export const DEFAULT_CHECKED_COLOR = "brand";
export const DEFAULT_UNCHECKED_COLOR = "text-tertiary";
